

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface SoStatusMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface SoStatusMst {
    id?:number;
    soStatus:string;
    soDescription:string;  
   
    createdIp:string;
 
    createdBy:number;
    createdDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: SoStatusMstParameter[];
    links?: any;
}

export abstract class SoStatusMstData { 
    abstract list(url: string): Observable<SoStatusMst[]>;
    abstract create(url: string,data: SoStatusMst): Observable<any>;
    abstract update(url: string,data: SoStatusMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
